import { createAsyncThunk } from '@reduxjs/toolkit';

import { _apiPathManagerConfig } from '../../../../Shared/ApiPaths/ApiPathManagerSetup';
import { BasicInfoHttpGetService } from '../../../Common/Common/Services/BasicInfoHttpService';
import IGetActiveCitiesQuery from '../../../Common/Common/Types/Queries/IGetActiveCitiesQuery';

export const getActiveCities = createAsyncThunk('City/getActiveCities', async (query?: IGetActiveCitiesQuery) => {
  return await BasicInfoHttpGetService({
    url: `${_apiPathManagerConfig?.BasicInfo.City.GetActiveCities}`,
    params: query,
  });
});
